import { render, staticRenderFns } from "./ProductID.vue?vue&type=template&id=6d491a4b&scoped=true"
import script from "./ProductID.vue?vue&type=script&lang=js"
export * from "./ProductID.vue?vue&type=script&lang=js"
import style0 from "./ProductID.vue?vue&type=style&index=0&id=6d491a4b&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d491a4b",
  null
  
)

export default component.exports